import axios from "axios";
import { ComplaintFilterModle } from "../../../ui/pages/complaint/listing";
import {
  fetchDelete,
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../api_client";
import { ComplaintCommentModel } from "../../models/complaint_model";
import { DeviceIdRegex } from "../../../utils/constant";
import { file_dir } from "../../../utils/enums";

export const CreateComplaint = async (data: FormData) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const UpdateComplaint = async (data: {
  [key: string]: any;
  id: string;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${data.id}`;
    const res = await fetchPut(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetComplaint = async (id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetOrgByDeviceId = async (id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/device/${id}`;
    console.log("id is:", id);
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetAddressByDeviceId = async (id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/device_address/${id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetComplaintCreationDetailsByMobile = async (
  mobile: string,
  device_id?: string,
) => {
  try {
    const rawMobile = String(mobile ?? "").trim();
    const rawDeviceId = String(device_id ?? "").trim();

    const inferredDeviceId = DeviceIdRegex.test(rawMobile.toLowerCase())
      ? rawMobile.toLowerCase()
      : "";

    const inferredMobile = inferredDeviceId ? "" : rawMobile;

    const resolvedDeviceId = rawDeviceId || inferredDeviceId || undefined;
    const resolvedMobile = inferredMobile || undefined;

    const query = toQueryString({
      phoneNumber: resolvedMobile,
      deviceId: resolvedDeviceId,
    });

    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/home-platform/customer-details${query}`;

    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const OrgSearchInComplaints = async (option: {
  count?: number;
  page?: number;
  search?: string;
  all?: boolean;
}) => {
  try {
    const url = `${
      process.env.REACT_APP_BACKEND_BASE_URL
    }/api/v3/complaint/org_search${toQueryString(option)}`;
    const res = await fetchGet(url);
    console.log("log", res.data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const CreateComplaintComment = async (data: ComplaintCommentModel) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${data.complaint_id}/comment`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const DeleteComplaintComment = async ({
  complaint_id,
  id,
}: {
  complaint_id: any;
  id: any;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/comment/${id}`;
    const res = await fetchDelete(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getComplaints = async (data: ComplaintFilterModle) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/get-complaints`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Re-attempt the Home App ticket creation for an Operations complaint that
// failed/skipped the sync on create (no oem_service_ticket_id yet).
export const retryHomeSync = async (id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/home-platform/retry-sync/${id}`;
    const res = await fetchPost(url, {});
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const exportComplaints = async (data: {
  search?: string;
  filterData?: {
    [key: string]: any;
    fromDate?: Date;
    toDate?: Date;
    complaintBy?: string[];
    complainRelatedTo?: string[];
    responsiblePerson?: string[];
    emp_name?: string;
    status?: string[];
    state?: string[];
    pre_post?: string[];
    priority?: string[];
    active?: boolean;
    sort_by?: string;
    sort_order?: string;
  };
}) => {
  try {
    const url = `${
      process.env.REACT_APP_BACKEND_BASE_URL
    }/api/v3/complaint/export${toQueryString(data)}`;
    const res = await fetchGet(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getComplaintComments = async ({
  page,
  count,
  all,
  complaint_id,
}: {
  complaint_id: string;
  page: number;
  count: number;
  all: any;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/comment?page=${page}&count=${count}&all=${all}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getComplaintLogs = async ({
  page,
  count,
  all,
  complaint_id,
}: {
  complaint_id: string;
  page: number;
  count: number;
  all: any;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/log?page=${page}&count=${count}&all=${all}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetComplaintWordCount = async () => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/cloud-word`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UploadComplaintAttachmentRepo = async (
  complaint_id: string,
  data: FormData,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/attachments`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const GetComplaintAttachmentRepo = async (complaint_id: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/attachments`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

/** Soft delete — the attachment just stops showing up, the S3 object is untouched. */
export const DeleteComplaintAttachmentRepo = async (
  complaint_id: string,
  id: string | number,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/attachments/${id}`;
    const res = await fetchDelete(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

/**
 * A signed PUT url for a single object — the browser writes straight to S3, no
 * multipart/backend proxying, since the compressed video is always well under
 * the multipart-recommended threshold.
 */
export const GetComplaintAttachmentSignedUrlApi = async ({
  mimetype,
  extension,
}: {
  mimetype: string;
  extension: string;
}) => {
  try {
    const query = { mimetype, extension, dir: file_dir.complaint };
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/signed-url`;
    const res = await fetchGet(url + toQueryString(query));
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UploadComplaintAttachmentToS3Api = async ({
  signed_url,
  file,
  onProgress,
}: {
  signed_url: string;
  file: File;
  onProgress?: (percent: number) => void;
}) => {
  try {
    await axios.put(signed_url, file, {
      headers: { "Content-Type": file.type },
      onUploadProgress: (event) =>
        onProgress?.(
          event.total ? Math.round((event.loaded / event.total) * 100) : 0,
        ),
    });
    return { success: true };
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

/** Links an object already in S3 (see the two functions above) to a complaint. */
export const AttachComplaintAttachmentApi = async (
  complaint_id: string,
  data: { url: string; mimetype: string; name?: string },
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/${complaint_id}/attachment-url`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const getIncidentsTrackerList = async (query: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/telecmi/tickets`;
    const res = await fetchGet(url + query);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const updateIncidentById = async (
  selectedComplainant: string,
  data: any,
) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/telecmi/update/${selectedComplainant}`;
    const res = await fetchPost(url, data);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ExportComplaintsByEmail = async (props: any) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/complaint/export-by-email`;

  const res = await fetchGet(url + props);
  return res;
};

// --- Complaint-to-Replacement pipeline: replacement_requests (Stages 1-2) ---

const REPLACEMENT_REQUESTS_BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/replacement-requests`;

export const RaiseReplacementRequest = async (complaint_id: string) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/${complaint_id}/raise`;
    const res = await fetchPost(url, {});
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ListReplacementRequestsForComplaint = async (
  complaint_id: string,
) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/by-complaint/${complaint_id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetReplacementRequest = async (id: string) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/${id}`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ApproveReplacementRequest = async (id: string) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/${id}/approve`;
    const res = await fetchPut(url, {});
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const RejectReplacementRequest = async (id: string, reason: string) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/${id}/reject`;
    const res = await fetchPut(url, { reason });
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const RetryDraftReplacementST = async (id: string) => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/${id}/retry-st`;
    const res = await fetchPut(url, {});
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ListPendingReplacementRequests = async () => {
  try {
    const url = `${REPLACEMENT_REQUESTS_BASE}/pending-approvals`;
    const res = await fetchGet(url);
    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
